// @flow
import get from 'lodash/get';
import { EVENT_NAME, API_TRACKING_ENDPOINT } from './constants';
import clientConfig from '../../../../parameters/client/config';
import TrackingApi from '../../../sdk/tracking/Api';
import { getCountryCode, getVerticalId } from '~/common/selectors/config';
import { getUserAgent, getUserIp, getQuery } from '~/common/selectors/trovit';

type ApiTrackingPayload = {
  country_code: string,
  vertical_id: string,
  alert_id: string,
  alert_type: string,
  vv: string,
  ip: string,
  user_agent: string,
};

export const apiInstance = new TrackingApi(clientConfig.trackingApi);

function apiTracking(state: Object): EventTracking {
  function mapStateToPayload(): ApiTrackingPayload {
    const query = getQuery(state);

    return {
      country_code: getCountryCode(state),
      vertical_id: getVerticalId(state),
      alert_id: get(query, 'id_search'),
      alert_type: get(query, 'from'),
      vv: get(query, 'tracking'),
      ip: getUserIp(state),
      user_agent: getUserAgent(state),
    };
  }

  function send() {
    const payload = mapStateToPayload();
    return apiInstance.sendTracking(API_TRACKING_ENDPOINT, payload);
  }

  return {
    name: EVENT_NAME,
    send,
    mapStateToPayload,
  };
}

export default apiTracking;



// WEBPACK FOOTER //
// ./app/tracking/events/internalstatsOpenAlert/apiTracking.js